// @flow

// Hocs
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Selectors
import addAccount$ from '../selectors/newAccount'

// components
import addAccountComponent from '../components/AddAccount'

// actions
import { updateAccountOperation } from '../actions'

// Operator
import composeOperator from 'hfty-operator-accounts/src/operator'

const accountsOperator = composeOperator()

function mapStateToProps (state: *): * {
  return {
    operation: addAccount$(state),
  }
}

type MapDispatchToProps = {
  actions: {
    onEdit: Function,
  }
}

function mapDispatchToProps (dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    actions: bindActionCreators({
      onChange: updateAccountOperation,
      onCancel: accountsOperator.actionCreators.cancelOperations,
      onSubmit: accountsOperator.actionCreators.submitOperations,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(addAccountComponent)
